export default function useQuery() {
  return new URLSearchParams(window.location.hash.split('?')[1]);
}



// WEBPACK FOOTER //
// ./src/hooks/useQuery.js